import { render, staticRenderFns } from "./81.vue?vue&type=template&id=02f2da14&scoped=true&"
var script = {}
import style0 from "./81.vue?vue&type=style&index=0&id=02f2da14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f2da14",
  null
  
)

export default component.exports